import ProductService from '@/services/product.service'
import BrandsService from '@/services/brands.service'
import ApiService from '@/services/_api.service'
import Utils from '@/utils'
import _ from 'lodash'

const state = {
    filterLoading: false,
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    brands: [],
    colorsPage: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    current: {},
    currentLoading: false,
    colorsReading: false
}

const getters = {}

const actions = {
    create: async ({ commit }, args) => {
        try {
            await ProductService.create(args)
            commit('createProductSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    read: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (!args.limit) args.limit = 20
        if (state.page.index == args.page) return true
        try {
            let page = ProductService.read(args)
            commit('reading')
            page = await page
            commit('readProductsSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readById: async ({ commit }, id) => {
        if (!id) return true

        try {
            let product = ProductService.readById(id)

            commit('readingProduct')
            product = await product
            commit('readProductSuccess', product.data)
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readColors: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.colorsPage.index == args.page) return true
        try {
            let page = ProductService.readColors(args)
            commit('readingProductColor')
            page = await page
            commit('readProductsColorSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    moreColors: async ({ commit }, url) => {
        if (!url) return

        try {
            let page = ApiService.readUrl(url)
            commit('readingProductColor')
            page = await page
            commit(
                'readProductsColorMoreSuccess',
                page.data,
                new URLSearchParams(url).get('page')
            )
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    clearColor: ({ commit }, new_results = []) => {
        commit(
            'readProductsColorSuccess',
            { results: new_results, count: 0, next: null, previous: null },
            null
        )
    },
    update: async ({ commit }, args) => {
        try {
            await ProductService.update(args.id, args)
            commit('updateProductSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    delete: async ({ commit }, { id }) => {
        try {
            await ProductService.delete(id)
            commit('deleteProductSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    createParameter: async ({ commit }, args) => {
        try {
            await ProductService.createParameter(args)
            commit('createParameterSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readBrands: async ({ commit }, args) => {
        try {
            let brands = await BrandsService.getBrands(args)
            commit('SET_BRANDS', brands)
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    async SET_BRANDS(state, { data }) {
        let brands = await data.results
        state.brands = brands
    },
    reading(state) {
        state.filterLoading = true
    },
    readingProductColor(state) {
        state.colorsReading = true
    },
    createProductSuccess(state) {
        // success
    },

    readProductsSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index

        state.filterLoading = false
    },
    readProductsColorSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.colorsPage = page
        state.colorsPage.index = page_index

        state.colorsReading = false
    },
    readProductsColorMoreSuccess(state, page, page_index) {
        state.colorsReading = false
        Utils.datetimeConverter(page.results)
        state.colorsPage.next = page.next
        state.colorsPage.previous = page.previous

        let current_results = _.cloneDeep(state.colorsPage.results)
        state.colorsPage.results = current_results.concat(page.results)

        state.colorsPage.index = page_index
    },
    readingProduct(state) {
        state.currentLoading = true
    },
    readProductSuccess(state, product) {
        state.currentLoading = false
        state.current = product
    },

    updateProductSuccess(state) {
        // success
    },

    deleteProductSuccess(state) {
        // success
    },

    createParameterSuccess(state) {
        // success
    },

    mapNames(state) {
        state.page.results = state.page.results.map(product => {
            product.name = product.external_id + ' - ' + product.name
            return product
        })
    }
}

const products = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default products
export { products }
